import { DateTime } from 'luxon';
import type { QuickFilterOption } from 'components/quickFilters';

/** Espelha `CHARGE_QUICK_FILTERS` do servidor; a regra de cada um mora lá. */
export const CHARGE_QUICK_FILTERS: QuickFilterOption[] = [
  { value: '', label: 'Todas' },
  { value: 'PENDING', label: 'Pendentes' },
  { value: 'DUE_TODAY', label: 'Vence hoje' },
  { value: 'OVERDUE', label: 'Vencidas' },
  { value: 'PAID', label: 'Pagas' },
];

/** Mês do vencimento, relativo ao de hoje; espelha `CHARGE_DUE_MONTHS` do servidor. */
export const CHARGE_DUE_MONTHS: QuickFilterOption[] = [
  { value: 'PREVIOUS', label: 'Mês anterior' },
  { value: 'CURRENT', label: 'Mês atual' },
  { value: 'NEXT', label: 'Próximo mês' },
];

/**
 * Vencimento na listagem. O boleto usa o `dueDate` que o servidor já resolveu (o
 * dia registrado no banco): reconverter o `expireAt` no fuso do navegador mostraria
 * a véspera. O Pix expira em horas, então vale a hora, no horário de quem vê.
 */
export const formatChargeDueDate = (row: {
  chargeType?: string;
  dueDate?: string | null;
  expireAt?: string | null;
}): string => {
  if (row.chargeType === 'PIX') {
    return row.expireAt ? DateTime.fromISO(row.expireAt).toFormat('dd/MM/yyyy HH:mm') : '—';
  }
  return row.dueDate ? DateTime.fromISO(row.dueDate).toFormat('dd/MM/yyyy') : '—';
};
